import {Component, ElementRef, EventEmitter, HostBinding, Input, OnDestroy, Output} from "@angular/core";
import {FUIEventsService} from "../../events/events.service";
import {Subscription} from "rxjs";

@Component({
    selector: "fui-page-refresh",
    styleUrls: ["./page-refresh.component.scss"],
    templateUrl: "./page-refresh.component.html"
})
export class FUIPageRefreshComponent implements OnDestroy {
    public _complete: boolean;
    public _lock: boolean;
    public movement: number;
    @HostBinding("style.top.px") public offset: number;
    @Output() public ready: EventEmitter<boolean>;
    public start: number;

    private subscriptions: Subscription = new Subscription();

    constructor(private elementRef: ElementRef,
                private eventsService: FUIEventsService) {
        this.ready = new EventEmitter<boolean>();
        this.lock = false;
        this.movement = 0;
        this.offset = 0;
        this.start = 0;

        this.subscriptions.add(this.eventsService.touch$.subscribe(
            (event: TouchEvent) => {
                if (this.lock) {
                    // If the loader is currently locked and a new event occurs
                }
                else {
                    if (event.currentTarget["scrollTop"] === 0) {
                        if (event.type === "touchstart") {
                            this.start = event.changedTouches.item(0).clientY;
                        }
                        else if (event.type === "touchmove") {
                            if (event.changedTouches.item(0).clientY > 80) {
                                this.movement = event.changedTouches.item(0).clientY;

                                if ((this.movement - this.start) < 125) {
                                    this.offset = this.movement - this.start;
                                }
                            }
                        }
                        else if (event.type === "touchend") {
                            if (this.offset > 30) {
                                this.offset = 80;
                                this.lock = true;
                            }
                            else {
                                this.offset = 0;
                                this.lock = false;
                            }
                        }
                    }
                }
            }
        ));
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    /**
     *
     * @returns {boolean}
     */
    get complete(): boolean {
        return this._complete;
    }

    /**
     *
     * @param {boolean} value
     */
    @Input()
    set complete(value: boolean) {
        this._complete = value;
        this.lock = false;
        this.offset = 0;

        if (this.complete) {
            this.movement = 0;
            this.offset = 0;
            this.start = 0;

        }

    }

    /**
     *
     * @returns {boolean}
     */
    get lock(): boolean {
        return this._lock;
    }

    /**
     *
     * @param {boolean} value
     */
    @Output()
    set lock(value: boolean) {
        this._lock = value;

        if (this.lock) {
            this.ready.emit(this.lock);
        }
    }
}
